import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { tenantWebsiteCards } from '../../../../redux/tenant-website-cards/action';
import { useSelector } from 'react-redux';
import { selectTenantWebsiteCardsListItems} from '../../../../redux/tenant-website-cards/selector';
import { deepCopy, transformBackCardValues, transformCardValues } from '../../../../common/services/common.service';
import * as R from 'ramda';
import TenantWebsitesCardComponent from '../components/tenant-website-card.component';
import { selectCurrent } from '../../../../redux/settings/selectors';
import { settings } from '../../../../redux/settings/actions';
import UploadFiles from '../../../../models/UploadFile';
import PageLoader from '../../../../components/PageLoader';
import { products } from '../../../../redux/products/action';
import { categories } from '../../../../redux/categories/action';
import { selectProductListItems } from '../../../../redux/products/selector';
import { selectCategoriesListItems } from '../../../../redux/categories/selector';

let currentChange: any = {}
const TenantWebsiteCard= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const productsData = useSelector(selectProductListItems)
  const categoriesData = useSelector(selectCategoriesListItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const {tenantId, platformWebSiteId,id} = useParams()
  const orderItems = useSelector(selectTenantWebsiteCardsListItems)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalProductOpen, setIsProductModalOpen] = useState(false);
 
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleOpenProductModal = () => setIsProductModalOpen(true);
  const handleCloseProductModal = () => setIsProductModalOpen(false);
  const [
    categoryColumnDefs,
    setCategoryColumnDefs
  ] = useState({});
  const createCategoryColumnDefs: any = () => {
    setCategoryColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      
      { field: 'CategoryName', headerName: 'Category Name' , isEdit: true},
       { field: 'IsPublished', headerName: 'Published', cellRenderer: 'yesNoRenderer' },
       { field: 'DisplayOrder', headerName: 'Display Order' },
       { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat:true},
       { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat:true } 
  
    ]);
  }
  
  const [
    productColumnDefs,
    setProductColumnDefs
  ] = useState({});
  const createProductColumnDefs: any = () => {
    setProductColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      
      {
        field: 'Message.MediaMappings.MediaFiles[0].FileMappingURL',
        headerName: 'Image',
        sortable: false,
        filter: false,
        cellRenderer: 'imageRenderer',
        
      },
      {
        field: 'Message.ProductCode',
        headerName: 'Product Code',
        sortable: true,
        filter: true,
        
      },
      {
        field: 'Message.Name',
        headerName: 'Name',
        sortable: true,
        filter: true,
        isEdit: true,
      },
      { field: 'Message.UOMName', headerName: 'UOM Name', filter: true },
      {
        field: 'Message.Price',
        headerName: 'Price',
        sortable: true,
       isCurrencyValueFormat: true,
      },
      { field: 'Message.StockQuantity', headerName: 'StockQuantity' },
      {
        field: 'Message.IsPublishedInCSP',
        headerName: 'Published In CSP',
        cellRenderer: 'yesNoRenderer',
      },
      {
        field: 'Message.IsPublishedInOpenNetwork',
        headerName: 'Published In OpenNetwork',
        cellRenderer: 'yesNoRenderer',
      },
      {
        field: 'Message.sPublishedInService',
        headerName: 'Published In Service',
        cellRenderer: 'yesNoRenderer',
      },
      {
        field: 'Message.IsAvailable',
        headerName: 'Avilable',
        cellRenderer: 'yesNoRenderer',
      },
      {
        field: 'Message.CreatedOnUtc',
        headerName: 'Created On',
        isDateValueFormat: true,
        sortable: true,
      },
  
    ]);
  }
  const [
    cardValues,
    setCardValues
  ] = useState<any>([]);
  const [
    cardTemplate,
    setCardTemplate
  ] = useState<any>([]);
 
  const [
    tenantWebCards,
    setTenantWebCards
  ] = useState<any>([]);
  const [
    cardImageIndex,
    setCardImageIndex
  ] = useState<any>([])

  const handleFormChange: any = ({ field, value, idx }: any) => {
    const items = deepCopy(cardValues);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setCardValues(items);
  }
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
  const changeCardFile = (idx: number, templateField: any, fileType: any) => {
    setCardImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: cardValues[idx][templateField],
      folder: 'website',
      type: fileType
    })
    currentChange = { idx, templateField }
  }
  const handleSubmit = (data: any) => {
    cardValues[cardImageIndex][currentChange.templateField] = data
    const localSelectedMedia = addNewRow({ cardValuesArg: cardValues });
    setCardValues(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
  const fetchTenantWebsiteCardsById= ()=>{
    dispatch(tenantWebsiteCards.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
      entity: 'tenantWebsiteCards',
      jsonData: {
          "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              },
              {
                  "FieldName": "PlatformWebSiteId",
                  "FieldType": "number",
                  "FilterOperatorId": 1,
                  "FieldValue": platformWebSiteId
              },
              {
                "FieldName": "Id",
                "FieldType": "number",
                "FilterOperatorId": 1,
                "FieldValue": id
            }
            ],
      }
  })).then(()=>{
  setIsQuery(true)
})
  }

const addNewRow = ({ cardValuesArg }: any) => {
  const localCardValues = deepCopy(cardValuesArg)
  let newCardValueRecord = {};
  R.map((template: any) => {
    newCardValueRecord = R.assoc(
      template.field,
      '',
      newCardValueRecord
    )
    return newCardValueRecord;
  })(cardTemplate)
  const isLastRowFilledWithData = R.any(R.complement(R.isEmpty))(R.values(localCardValues[localCardValues.length - 1]));

  if (localCardValues.length === 0 ||
    isLastRowFilledWithData
  ) {
    localCardValues?.push(newCardValueRecord)
  }
  return localCardValues
}
const getIsWebPageCard = () => currentChange.field === 'title' || currentChange.field === 'src' || currentChange.field === 'subtitle'
const setTenantWebsiteCardInfo = async () => {
  let localCardItems = deepCopy(cardValues)
  localCardItems.splice(
    currentChange.idx,
    1,
    { ...localCardItems[currentChange.idx] }
  );
  localCardItems = addNewRow({ cardValuesArg: localCardItems });

  currentChange.field = getIsWebPageCard()
  setCardValues(localCardItems)
}
const back=()=>{
    navigate(`/web-platform/platform-management/tenants/${tenantId}/${platformWebSiteId}/`)
} 


  useEffect(
    () => {
      dispatch(products.list({
        url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/catalog/products/list`,
        entity: 'products',
        jsonData: {"PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "Id",
            "SortOrder": "desc",}
    }))
    .then(() => {
      dispatch(categories.list({
        url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
        entity: 'categories',
        jsonData: {"PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "Id",
            "SortOrder": "desc",}
    }))})
    createCategoryColumnDefs()
    createProductColumnDefs()
        if (Number(id) > 0) {
       
            fetchTenantWebsiteCardsById()
            setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setTenantWebCards(orderItems?.result?.items[0])
        setCardTemplate(JSON.parse(orderItems?.result?.items[0]?.CardValue)[0])
        const localCard = addNewRow({ cardValuesArg: transformCardValues(JSON.parse(orderItems?.result?.items[0]?.CardValue)) })
     setCardValues(localCard)
      }
    },
    [isQuery]
  )
  useEffect(
    () => {
      if (currentChange.field) {
        setTenantWebsiteCardInfo()
      }
    },
    [cardValues]
  )
  const handleDeleteCollectionCard = async () =>{
    const backTransformedCard = transformBackCardValues(JSON.stringify(cardValues))
      dispatch(tenantWebsiteCards.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`,entity:'tenantWebsiteCards',jsonData:{
     
      Records: [
        {
          context: {},
          message: {
        TenantId: tenantId,
        Id: tenantWebCards?.Id,
        StoreId: tenantWebCards?.StoreId,
        DepartmentId: tenantWebCards?.DepartmentId,
        WebSiteName: tenantWebCards?.WebsiteName,
        PlatformWebSiteId: tenantWebCards?.PlatformWebSiteId,
        PlatformWebSitePageId: tenantWebCards?.PlatformWebSitePageId || 0,
        PlatformWebSiteLayoutId: tenantWebCards?.PlatformWebSiteLayoutId,
        PlatformWebSiteLayoutCardId: tenantWebCards?.PlatformWebSiteLayoutCardId,
        CardValue: backTransformedCard,
        CardTypeId: tenantWebCards?.CardTypeId,
        CardVersionId: tenantWebCards?.CardVersionId || 0,
        Remarks: tenantWebCards?.Remarks,
        HostingUrl: tenantWebCards?.HostingUrl,
        MappedDomain: tenantWebCards?.MappedDomain,
        DisplayOrder: tenantWebCards?.DisplayOrder || 0
          }
        }
      ]
  
 }})).then(()=>{
  back()
})
 
  }
   const deleteTenantwebCardItem = async (Item: any, index: any) => {
    if(!selectedRows){
      handleDeleteCollectionCard()
    }
    
    else{
    const card = deepCopy(cardValues)
    card.splice(
      index,
      1
    )
   
      const backTransformedCard = transformBackCardValues(JSON.stringify(card))
      dispatch(tenantWebsiteCards.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`,entity:'tenantWebsiteCards',jsonData:{
     
      Records: [
        {
          context: {},
          message: {
        TenantId: tenantId,
        Id: tenantWebCards?.Id,
        StoreId: tenantWebCards?.StoreId,
        DepartmentId: tenantWebCards?.DepartmentId,
        WebSiteName: tenantWebCards?.WebsiteName,
        PlatformWebSiteId: tenantWebCards?.PlatformWebSiteId,
        PlatformWebSitePageId: tenantWebCards?.PlatformWebSitePageId || 0,
        PlatformWebSiteLayoutId: tenantWebCards?.PlatformWebSiteLayoutId,
        PlatformWebSiteLayoutCardId: tenantWebCards?.PlatformWebSiteLayoutCardId,
        CardValue: backTransformedCard,
        CardTypeId: tenantWebCards?.CardTypeId,
        CardVersionId: tenantWebCards?.CardVersionId || 0,
        Remarks: tenantWebCards?.Remarks,
        HostingUrl: tenantWebCards?.HostingUrl,
        MappedDomain: tenantWebCards?.MappedDomain,
        DisplayOrder: tenantWebCards?.DisplayOrder || 0
          }
        }
      ]
  
 }})).then(()=>{
  back()
})
 

}
  }
  const handleCollectionsCard = async () =>{
  const backTransformedCard = transformBackCardValues(JSON.stringify(cardValues))
  await dispatch(tenantWebsiteCards.resetAction({ actionType: 'update' }))
  await dispatch(tenantWebsiteCards.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`,entity:'tenantWebsiteCards',jsonData:{
           
      Records: [
        {
          Context: {},
          Message: {
            TenantId: tenantId,
            Id: tenantWebCards?.Id,
        StoreId: tenantWebCards?.StoreId,
        DepartmentId: tenantWebCards?.DepartmentId,
        WebSiteName: tenantWebCards?.WebsiteName,
        PlatformWebSiteId: tenantWebCards?.PlatformWebSiteId,
        PlatformWebSitePageId: tenantWebCards?.PlatformWebSitePageId || 0,
        PlatformWebSiteLayoutId: tenantWebCards?.PlatformWebSiteLayoutId,
        PlatformWebSiteLayoutCardId: tenantWebCards?.PlatformWebSiteLayoutCardId,
        CardValue: backTransformedCard,
        CardTypeId: tenantWebCards?.CardTypeId,
        CardVersionId: tenantWebCards?.CardVersionId || 0,
        Remarks: tenantWebCards?.Remarks,
        HostingUrl: tenantWebCards?.HostingUrl || "",
        MappedDomain: tenantWebCards?.MappedDomain || "",
        DisplayOrder: tenantWebCards?.DisplayOrder || 0
          }
        }
      ]
  
 }})).then(()=>{
  back()
})
}
  const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if(selectedRows){
      handleCollectionsCard()
     }
     else{
    const card = deepCopy(cardValues)
    card.splice(
      card.length - 1,
      1
    )
   
      const backTransformedCard = transformBackCardValues(JSON.stringify(card))
      await dispatch(tenantWebsiteCards.resetAction({ actionType: 'update' }))
      await dispatch(tenantWebsiteCards.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards`,entity:'tenantWebsiteCards',jsonData:{
           
      Records: [
        {
          Context: {},
          Message: {
            TenantId: tenantId,
            Id: tenantWebCards?.Id,
        StoreId: tenantWebCards?.StoreId,
        DepartmentId: tenantWebCards?.DepartmentId,
        WebSiteName: tenantWebCards?.WebsiteName,
        PlatformWebSiteId: tenantWebCards?.PlatformWebSiteId,
        PlatformWebSitePageId: tenantWebCards?.PlatformWebSitePageId || 0,
        PlatformWebSiteLayoutId: tenantWebCards?.PlatformWebSiteLayoutId,
        PlatformWebSiteLayoutCardId: tenantWebCards?.PlatformWebSiteLayoutCardId,
        CardValue: backTransformedCard,
        CardTypeId: tenantWebCards?.CardTypeId,
        CardVersionId: tenantWebCards?.CardVersionId || 0,
        Remarks: tenantWebCards?.Remarks,
        HostingUrl: tenantWebCards?.HostingUrl || "",
        MappedDomain: tenantWebCards?.MappedDomain || "",
        DisplayOrder: tenantWebCards?.DisplayOrder || 0
          }
        }
      ]
  
 }})).then(()=>{
  back()
})
 
} 
   
  }
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const handleRowSelection = (row: any, checked: boolean) => {
   if (checked) {
     setSelectedRows((prev) => [...prev, row]);
   } else {
     setSelectedRows((prev) => prev.filter((item) => item !== row));
   }
 };

 const handleAddCollections = () => {
   if(selectedRows[0]?.Message?.ProductCode){
  const updatedCardValues = transformCardValue(selectedRows, cardTemplate);
  setCardValues(updatedCardValues);
  handleCloseProductModal()
   }
   if(selectedRows[0]?.CategoryName || selectedRows[0]?.CategoryCode){
     const updatedCardValues = transformCardValueCategory(selectedRows, cardTemplate);
     setCardValues(updatedCardValues);
     handleCloseModal()
      }

 };

 const transformCardValueCategory = (selectedRows: any[], cardTemplate: any[]): any[] => {
  return selectedRows.map(row => {
    const transformedCard: any = {};
    cardTemplate.forEach(template => {
      const field = template.field;
      if (field === 'src' && row?.MediaMappings?.MediaFiles?.length) {
        transformedCard[field] = row.MediaMappings.MediaFiles[0]?.FileMappingURL || '';
      } 
      else if(field === 'id'|| field ==='categoryId')
        {
          transformedCard[field] = row?.Id || '';
        }
        else if (field === 'name'||field ==='categoryName') {
        transformedCard[field] = row?.Name || '';
      } else if (field === 'code'|| field=== 'categoryCode') {
        transformedCard[field] = row?.CategoryCode || '';
      } else if (field === 'price') {
        transformedCard[field] = row?.Price || '';
      } else if (field === 'description') {
        transformedCard[field] = row?.Description || '';
      } else if (field === 'category') {
        transformedCard[field] = row
      } else {
        transformedCard[field] = '';
      }
    });

    return transformedCard;

  });
  
};

const transformCardValue = (selectedRows: any[], cardTemplate: any[]): any[] => {
  return selectedRows.map(row => {
    const transformedCard: any = {};
    const message = row?.Message || {};
    cardTemplate.forEach(template => {
      const field = template.field;
      if (field === 'src' && message?.MediaMappings?.MediaFiles?.length) {
        transformedCard[field] = message.MediaMappings.MediaFiles[0]?.FileMappingURL || '';
      } 
      else if(field === 'id'|| field ==='productId')
        {
          transformedCard[field] = message?.Id || '';
        }
      else if (field === 'name' || field ==='productName') {
        transformedCard[field] = message?.Name || '';
      } else if (field === 'code' || field ==='productCode') {
        transformedCard[field] = message?.ProductCode || '';
      } else if (field === 'price') {
        transformedCard[field] = message?.Price || '';
      }
      else if ((field === 'productCombinationId'|| 'combinationId') && message?.ProductAttributeCombinations) {
        transformedCard[field] = message?.ProductAttributeCombinations?.ProductAttributeCombinationId || '';
      }
      else if (field === 'vendorName') {
        transformedCard[field] = message?.VendorName || '';
      }   else if (field === 'description') {
        transformedCard[field] = message?.Description || '';
      } else if (field === 'product') {
        transformedCard[field] = row
      } else {
        // transformedCard[field] = '';
      }
    });

    return transformedCard;

  });
  
};






 const additionButtons: any = [
   {
     name: 'Add Collection',
     callback: () => handleAddCollections(),
   }
 ];


    return (
    <>
      {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={id}
         tenantId={tenantId}
         />}
       {isLoading ? <PageLoader /> : 
          <TenantWebsitesCardComponent 
          handleFormSubmit={handleFormSubmit}
           back={back}
          cardTemplate={cardTemplate}
          cardValues={cardValues}
          handleFormChange={handleFormChange}
          deleteTenantwebCardItem={deleteTenantwebCardItem}
          changeCardFile={changeCardFile}
          products={productsData?.result?.items}
           categories={categoriesData?.result?.items}
           categoryColumnDefs={categoryColumnDefs}
           setPageData={setPageData}
           categoriesPaginationData={categoriesData?.result?.pagination}
           productsPaginationData={productsData?.result?.pagination}
           productColumnDefs={productColumnDefs}
           setPageSize={setPageSize}
           onSelect={handleRowSelection}
           additionButtons={additionButtons}
           isModalOpen={isModalOpen}
           isModalProductOpen={isModalProductOpen}
           handleOpenModal ={handleOpenModal}
           handleCloseModal ={handleCloseModal}
           handleOpenProductModal ={handleOpenProductModal}
           handleCloseProductModal ={handleCloseProductModal}
          />  
    }
          </>
        

      )
    
    }
   
    export default TenantWebsiteCard;